import React, { useState } from "react";
import {
  Button,
  Form,
  InputGroup,
  ToggleButton,
  ToggleButtonGroup,
} from "react-bootstrap";
import Input from "../Builder/nodes/Logic/Inputs/Input";
import AddIcon from "../../assets/icons/Icon_Library/application icons/assets/events/add_circle-01.svg2";
import InputLabel from "../Builder/nodes/Logic/Inputs/InputLabel";
import MyCollapse from "../Common/MyCollapse";
import RequestHeader from "./RequestHeader";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import HelpButton from "../HelpContent/HelpButton";

export default function FrequencyForm({ check, setCheck, checkType, monitor }) {
  const [isMultiDate, setIsMultiDate] = useState(false);
  const [newHeader, setNewHeader] = useState({ key: "", value: "" });
  const [dateValue, setDateValue] = useState();
  return (
    <div className=" ">
      <div>
        <span className="fs-4 fw-bold ">Frequency Details </span>
        <div className="text-secondary small mb-1">
          Define the monitoring intervals, selecting either fixed intervals or
          specified times
        </div>
      </div>

      <div className="w-100">
        <ToggleButtonGroup
          type="radio"
          value={check.FrequencyKind}
          onChange={(value) => setCheck({ ...check, FrequencyKind: value })}
          name={`howOften-${checkType}`}
          className="mb-3 my-2"
        >
          <ToggleButton
            id={`tbg-btn-1-${checkType}`}
            value={"interval"}
            variant="secondary"
            className="fs-bold text-start"
          >
            <div className="fw-bold"> Monitor at Fixed Intervals</div>
            <div className="text-white small">
              Runs automatically every set period (for example, every 5 or 15
              minutes) to check system status.
            </div>
          </ToggleButton>
          <ToggleButton
            id={`tbg-btn-2-${checkType}`}
            value={"fixed"}
            variant="secondary"
            className="fs-bold text-start"
          >
            <div className="fw-bold"> Monitor at Fixed Time</div>
            <div className="text-white small">
              Runs once or at scheduled times you choose, such as selecting a
              specific time like 1:30 PM during setup
            </div>
          </ToggleButton>
        </ToggleButtonGroup>
        {check.FrequencyKind === "interval" && (
          <>
            <InputGroup className="mb-3">
              <InputGroup.Text>Every</InputGroup.Text>
              <Form.Control
                aria-label="Every"
                value={check.IntervalValue || 0}
                onChange={(e) =>
                  setCheck({
                    ...check,
                    IntervalValue: parseInt(e.target.value || 0, 10),
                  })
                }
              />
              <Form.Select
                aria-label="Default select example"
                value={check.IntervalUnit}
                onChange={(e) =>
                  setCheck({ ...check, IntervalUnit: e.target.value })
                }
              >
                <option value="minute">minutes</option>
                <option value="hour">hours</option>
                <option value="day">days</option>
              </Form.Select>
            </InputGroup>
            <div className="row">
              {check.IntervalUnit === "day" && (
                <div className="col-6">
                  <InputGroup className="mb-3">
                    <InputGroup.Text>Run at</InputGroup.Text>
                    <Form.Control
                      type="number"
                      min={0}
                      max={23}
                      aria-label="Every"
                      value={check.IntervalRunAtHour || 0}
                      onChange={(e) =>
                        setCheck({
                          ...check,
                          IntervalRunAtHour: parseInt(e.target.value || 0, 10),
                        })
                      }
                    />
                    <InputGroup.Text>hour</InputGroup.Text>
                  </InputGroup>
                </div>
              )}
              {(check.IntervalUnit === "hour" ||
                check.IntervalUnit === "day") && (
                <div className="col-6">
                  <InputGroup className="col-6 mb-3">
                    <InputGroup.Text>Run at</InputGroup.Text>
                    <Form.Control
                      type="number"
                      min={0}
                      max={59}
                      aria-label="Every"
                      value={check.IntervalRunAtMinute || 0}
                      onChange={(e) =>
                        setCheck({
                          ...check,
                          IntervalRunAtMinute: parseInt(
                            e.target.value || 0,
                            10
                          ),
                        })
                      }
                    />
                    <InputGroup.Text>minute</InputGroup.Text>
                  </InputGroup>
                </div>
              )}
            </div>
          </>
        )}
        {check.FrequencyKind === "fixed" && (
          <div className="row g-2 mb-3">
            <div className="col-6">
              <Input
                isMulti
                inputType="select"
                label="Hours"
                onChange={(values) => {
                  if (values.includes("") && check.Minutes?.includes("")) {
                    return;
                  }
                  if (values.includes("")) {
                    setCheck({ ...check, Hours: [] });
                    return;
                  }
                  setCheck({ ...check, Hours: values.map(Number) });
                }}
                value={check.Hours || []}
                isValidNewOption={(v) => v.trim()}
                placeholder="if no hour selected, it means every hour"
                isClearable
                options={[
                  { value: "", label: "Every Hour" },
                  ...Array.from({ length: 24 }, (_, i) => ({
                    value: i,
                    label: i.toString().padStart(2, "0"),
                  })),
                ]}
              />
            </div>
            <div className="col-6">
              <Input
                placeholder="if no minute selected, it means every minute"
                isMulti
                label="Minutes"
                onChange={(values) => {
                  if (values.includes("") && check.Hours?.includes("")) {
                    return;
                  }
                  if (values.includes("")) {
                    setCheck({ ...check, Minutes: [] });
                    return;
                  }
                  setCheck({ ...check, Minutes: values.map(Number) });
                }}
                value={check.Minutes || []}
                isValidNewOption={(v) => v.trim()}
                inputType="select"
                isClearable
                options={[
                  { value: "", label: "Every Minute" },
                  ...Array.from({ length: 60 }, (_, i) => ({
                    value: i,
                    label: i.toString().padStart(2, "0"),
                  })),
                ]}
              />
            </div>
          </div>
        )}

        <div className="">
          <MyCollapse
            title="Select specific dates for monitoring"
            heading={<div className="fw-bold fs-4">Advanced options</div>}
          >
            <div className="my-3">
              <Input
                label="Which day"
                onChange={(values) => {
                  if (!values?.length) {
                    return;
                  }
                  setCheck({
                    ...check,
                    WeekDays: values.includes("everyday")
                      ? [0, 1, 2, 3, 4, 5, 6]
                      : values,
                  });
                }}
                placeholder="Nothing selected means everyday"
                isMulti
                value={check.WeekDays || []}
                options={[
                  { value: "everyday", label: "Select all" },
                  { value: 1, label: "Monday" },
                  { value: 2, label: "Tuesday" },
                  { value: 3, label: "Wednesday" },
                  { value: 4, label: "Thursday" },
                  { value: 5, label: "Friday" },
                  { value: 6, label: "Saturday" },
                  { value: 0, label: "Sunday" },
                ]}
              />
              <div className="my-3">
                <InputLabel>
                  <div className="fw-bold mt-2">Ignore dates</div>
                  <div className="text-secondary small mb-1">
                    You can select multiple dates.
                  </div>
                </InputLabel>
                <div className="d-flex">
                  <Input
                    inputType="radio"
                    radioName={`whichDate-${checkType}`}
                    value={[isMultiDate]}
                    options={[
                      { value: false, label: "Single date" },
                      { value: true, label: "Date range" },
                    ]}
                    onChange={(value) => {
                      setIsMultiDate(value[0]);
                    }}
                  />
                  <Input
                    inputType="dateTime"
                    dateTimeType="date"
                    value={[dateValue?.start]}
                    onChange={(values) => {
                      if (!values || values.length === 0) {
                        return;
                      }
                      setDateValue({ ...(dateValue || {}), start: values[0] });
                    }}
                    options={[]}
                    minDate={new Date(monitor?.StartAt)}
                    maxDate={new Date(monitor?.EndAt)}
                    excludeDates={check.IgnoreDates?.map(
                      (d) => d.split("->")[0]
                    )}
                    excludeDateIntervals={check.IgnoreDates?.filter(
                      (d) => d.search("->") !== -1
                    )?.map((d) => ({
                      start: d.split("->")[0],
                      end: d.split("->")[1],
                    }))}
                  />
                  {!!isMultiDate && (
                    <Input
                      inputType="dateTime"
                      dateTimeType="date"
                      value={[dateValue?.end]}
                      onChange={(values) => {
                        if (!values || values.length === 0) {
                          return;
                        }
                        setDateValue({ ...(dateValue || {}), end: values[0] });
                      }}
                      options={[]}
                      minDate={new Date(monitor?.StartAt)}
                      maxDate={new Date(monitor?.EndAt)}
                      excludeDates={check.IgnoreDates?.map(
                        (d) => d.split("->")[0]
                      )}
                      excludeDateIntervals={check.IgnoreDates?.filter(
                        (d) => d.search("->") !== -1
                      )?.map((d) => ({
                        start: d.split("->")[0],
                        end: d.split("->")[1],
                      }))}
                    />
                  )}
                  <Button
                    className="border-0 p-0 ms-2 d-flex align-content-end"
                    variant=""
                    disabled={
                      !dateValue?.start || (isMultiDate && !dateValue?.end)
                    }
                    onClick={() => {
                      setCheck({
                        ...check,
                        IgnoreDates: [
                          ...(check.IgnoreDates || []),
                          `${dateValue.start}${
                            dateValue.end ? `-> ${dateValue.end}` : ""
                          }`,
                        ],
                      });
                      setDateValue(undefined);
                    }}
                  >
                    <AddIcon width={15} />
                  </Button>
                </div>
              </div>
              {!!check.IgnoreDates?.length && (
                <div className="text-secondary my-3">
                  <Input
                    isDateTimeUTC
                    value={check.IgnoreDates ? check.IgnoreDates : []}
                    onChange={(values) => {
                      setCheck({
                        ...check,
                        IgnoreDates: values,
                      });
                    }}
                    isMulti
                  />
                </div>
              )}
              <div className="row g-2 my-3">
                <div className="col-6">
                  <Input
                    placeholder="if no minute selected, it means every minute"
                    label="Initial delay(Minutes)"
                    type={"number"}
                    min={0}
                    onChange={(values) => {
                      if (!values || values.length === 0) {
                        return;
                      }
                      setCheck({ ...check, InitialDelay: parseInt(values[0]) });
                    }}
                    value={check.InitialDelay ? [check.InitialDelay] : []}
                    isValidNewOption={(v) => v.trim()}
                  />
                </div>
                <div className="col-6">
                  <Input
                    placeholder="if no second selected, it means every second"
                    label="Time out(Seconds)"
                    type={"number"}
                    min={1}
                    max={15}
                    onChange={(values) => {
                      if (!values || values.length === 0) {
                        return;
                      }
                      setCheck({ ...check, Timeout: parseInt(values[0]) });
                    }}
                    value={check.Timeout ? [check.Timeout] : []}
                    isValidNewOption={(v) => v.trim()}
                  />
                </div>
              </div>
              <div className="row g-2 my-3">
                {(checkType === "recovery" ||
                  (checkType === "liveness" &&
                    monitor.MonitorPings?.find(
                      (p) => p.PingKind === "recovery" && !p.IsActive
                    ))) && (
                  <div className="col-6">
                    <Input
                      placeholder="Success  threshold"
                      label="Success threshold"
                      type={"number"}
                      min={0}
                      onChange={(values) => {
                        if (!values || values.length === 0) {
                          return;
                        }
                        setCheck({
                          ...check,
                          SuccessThreshold: parseInt(values[0]),
                        });
                      }}
                      value={
                        check.SuccessThreshold ? [check.SuccessThreshold] : []
                      }
                      isValidNewOption={(v) => v.trim()}
                    />
                    <div className="text-secondary">
                      Success threshold is the minimum number of successful
                      checks required to consider the monitor healthy.
                    </div>
                  </div>
                )}
                {checkType === "liveness" && (
                  <div className="col-6">
                    <Input
                      placeholder="Failure threshold"
                      label="Failure threshold"
                      type={"number"}
                      min={0}
                      onChange={(values) => {
                        if (!values || values.length === 0) {
                          return;
                        }
                        setCheck({
                          ...check,
                          FailureThreshold: parseInt(values[0]),
                        });
                      }}
                      value={
                        check.FailureThreshold ? [check.FailureThreshold] : []
                      }
                      isValidNewOption={(v) => v.trim()}
                    />
                    <div className="text-secondary">
                      Failure threshold is the number of consecutive failed
                      checks before the monitor is considered unhealthy.
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="">
              <span className="fs-4 fw-bold">
                Request Headers{" "}
                <HelpButton helpKey="monitoring-request-header" />
              </span>
              <div className="d-flex align-items-end gap-2">
                <div className="flex-grow-1">
                  <Form.Group controlId="requestHeaderName">
                    <Form.Label className="fw-bold">Name:</Form.Label>
                    <Form.Control
                      type="text"
                      value={newHeader.key}
                      onChange={(e) => {
                        setNewHeader({
                          ...newHeader,
                          key: e.target.value,
                        });
                      }}
                    />
                  </Form.Group>
                </div>
                <div className="flex-grow-1">
                  <Form.Group controlId="requestHeaderValue">
                    <Form.Label className="fw-bold ">Value:</Form.Label>
                    <Form.Control
                      type="text"
                      value={newHeader.value}
                      onChange={(e) =>
                        setNewHeader({
                          ...newHeader,
                          value: e.target.value,
                        })
                      }
                    />
                  </Form.Group>
                </div>

                <div className="">
                  <Button
                    className="text-navy border-1 fw-bold bg-white border-0"
                    disabled={!newHeader.key || !newHeader.value}
                    onClick={() => {
                      const updatedHeaders = { ...check.Headers };

                      if (updatedHeaders.hasOwnProperty(newHeader.key)) {
                        toast.error("Header name already exists.");
                        return;
                      }
                      updatedHeaders[newHeader.key] = newHeader.value;
                      setCheck({
                        ...check,
                        Headers: updatedHeaders,
                      });
                      setNewHeader({ key: "", value: "" });
                    }}
                  >
                    <span>Add</span>
                  </Button>
                </div>
              </div>
              {check.Headers &&
                !!Object.entries(check.Headers)?.length &&
                check.name !== "tcpConnection" && (
                  <div className="my-3 bg-white p-3 rounded-3 fs-5 fw-bold">
                    <div className="ms-3">
                      <table className="table">
                        <tbody>
                          {Object.entries(check.Headers).map(
                            ([key, value], index) => (
                              <tr key={index}>
                                <td>{key}:</td>
                                <td>{value}</td>
                                <td className="text-end">
                                  <Button
                                    className="bg-transparent text-navy border-0 fw-bold p-0"
                                    onClick={() => {
                                      if (
                                        Object.keys(check.Headers).length === 0
                                      ) {
                                        toast.error(
                                          "No more headers to remove."
                                        );
                                        return;
                                      }
                                      const updatedHeaders = {
                                        ...check.Headers,
                                      };
                                      delete updatedHeaders[key];
                                      setCheck({
                                        ...check,
                                        Headers: updatedHeaders,
                                      });
                                    }}
                                  >
                                    <FontAwesomeIcon
                                      width={50}
                                      icon={faTimes}
                                    />
                                  </Button>
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
            </div>
          </MyCollapse>
        </div>
      </div>
    </div>
  );
}
